module.exports = __webpack_public_path__ + "img/platform@2x.d8e65372.png";